// Оставляет в контейнере случайные карточки: [data-random-pick="3"].
// Порядок оставшихся карточек сохраняется. Запускать до модулей, которые читают children (слайдер, переворот).
export default function randomCards() {
  document.querySelectorAll('[data-random-pick]').forEach((root) => {
    const count = parseInt(root.dataset.randomPick, 10);
    const cards = [...root.children];
    if (!count || cards.length <= count) return;

    const indexes = cards.map((_, index) => index);
    for (let i = indexes.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [indexes[i], indexes[j]] = [indexes[j], indexes[i]];
    }
    const picked = new Set(indexes.slice(0, count));

    cards.forEach((card, index) => {
      if (!picked.has(index)) card.remove();
    });
    root.classList.add('is-picked');
  });
}
